import React from "react";
import { Clock, CalendarDays, Target, BookOpen, ListChecks, Radio } from "lucide-react";

const PRIMARY = [
    { id: "time", label: "TIME", icon: CalendarDays },
    { id: "events", label: "EVENTS", icon: Target },
    { id: "docs", label: "DOCS", icon: BookOpen },
    { id: "tools", label: "TOOLS", icon: ListChecks },
    { id: "comms", label: "LET'S CHAT", icon: Radio },
];

export const MainNav = ({ primary, onChange, hideComms = false }) => {
    const items = hideComms ? PRIMARY.filter((t) => t.id !== "comms") : PRIMARY;
    return (
        <div
            className="rounded-xl border border-meye-border bg-meye-card/70 backdrop-blur-sm p-1.5 grid gap-1"
            style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
            data-testid="main-nav"
        >
            {items.map((t) => {
                const Icon = t.icon;
                const active = primary === t.id;
                return (
                    <button
                        key={t.id}
                        onClick={() => onChange(t.id)}
                        className={`flex flex-col items-center justify-center gap-1 py-2 rounded-lg transition-all ${
                            active
                                ? "bg-gradient-to-b from-violet-600/70 to-violet-700/40 border border-violet-400/50 text-white shadow-[0_0_14px_rgba(139,92,246,0.35)]"
                                : "text-zinc-400 hover:text-zinc-100"
                        }`}
                        data-testid={`main-nav-${t.id}`}
                    >
                        <Icon size={16} strokeWidth={1.75} />
                        <span className="text-[9px] font-brand font-semibold tracking-wider">{t.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export const SUB_TABS = {
    time: [
        { id: "daily", label: "DAILY" },
        { id: "weekly", label: "WEEKLY" },
        { id: "monthly", label: "MONTHLY" },
    ],
    events: [
        { id: "events", label: "EVENTS" },
        { id: "recurring", label: "RECURRING" },
    ],
    docs: [
        { id: "notes", label: "NOTES" },
        { id: "ledger", label: "LEDGER" },
        { id: "scratchpad", label: "SCRATCHPAD" },
        { id: "inventory", label: "INVENTORY" },
        { id: "bookmarks", label: "BOOKMARKS" },
    ],
    tools: [
        { id: "checklists", label: "CHECKLISTS" },
        { id: "glossary", label: "GLOSSARY" },
        { id: "archive", label: "ARCHIVE" },
        { id: "backup", label: "BACKUP" },
        { id: "cleanup", label: "CLEANUP" },
        { id: "diagnostics", label: "DIAGNOSTICS" },
    ],
    comms: [],
};

export const SubNav = ({ tabs, active, onChange }) => {
    if (!tabs?.length) return null;
    return (
        <div className="mt-3 grid gap-1.5" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }} data-testid="sub-nav">
            {tabs.map((t) => {
                const isActive = active === t.id;
                return (
                    <button
                        key={t.id}
                        onClick={() => onChange(t.id)}
                        className={`px-3 py-2 rounded-full text-[11px] font-brand font-bold tracking-widest transition-all ${
                            isActive
                                ? "bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white shadow-[0_0_14px_rgba(217,70,239,0.3)]"
                                : "bg-meye-card border border-meye-border text-zinc-400 hover:text-zinc-200"
                        }`}
                        data-testid={`sub-nav-${t.id}`}
                    >
                        {t.label}
                    </button>
                );
            })}
        </div>
    );
};

export default MainNav;
